var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangle = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "8px",
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86BE4481-846D-47B5-88BE-C1F2D5320439") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maintenance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Homepage-Maintenance",
    transform: "translate(-208.000000, -487.000000)",
    fill: "#707372"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.847998,488.356797 L217.043751,493.470001 C217.336461,493.938338 217.194088,494.555288 216.725751,494.847998 C216.56682,494.947331 216.383172,495 216.195752,495 L209.804248,495 C209.251963,495 208.804248,494.552285 208.804248,494 C208.804248,493.81258 208.856917,493.628933 208.956249,493.470001 L212.152002,488.356797 C212.444712,487.888461 213.061662,487.746088 213.529999,488.038798 C213.658768,488.119279 213.767518,488.228028 213.847998,488.356797 Z",
    id: "Triangle",
    transform: "translate(213.000000, 491.000000) rotate(180.000000) translate(-213.000000, -491.000000) "
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Triangle.a533585b51bb430a1cc22e41a40e9c65.svg";